import { render, staticRenderFns } from "./QScoreCardFilters.vue?vue&type=template&id=35b26367&scoped=true&"
import script from "./QScoreCardFilters.vue?vue&type=script&lang=js&"
export * from "./QScoreCardFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35b26367",
  null
  
)

export default component.exports